import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  BrowserRouter as Router,
  Link,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import axios from "axios";
import OldDueCollection from "./OldDueCollection";
import OldDueList from "./OldDueList";
import ViewSettlement from "./ViewSettlement";
import SettlementFeeAdvance from "./SettlementFeeAdvance";
import uploadIcon from "../resources/images/upload-icon.png";
import MdlSelectSession from "../dialog/MdlSelectSession";
import BackButton from "../ChildComponent/BackButton";
import COLORS from "../resources/colors/COLORS";
import {
  FaCheck,
  FaClock,
  FaFileInvoiceDollar,
  FaHandHoldingUsd,
  FaListUl,
  FaRupeeSign,
  FaSyncAlt,
  FaTimes,
  FaUserGraduate,
} from "react-icons/fa";

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const TABS = [
  { value: "1", label: "Pending", color: "#f59e0b", icon: FaClock },
  { value: "2", label: "Settled", color: "#10b981", icon: FaCheck },
  { value: "3", label: "Rejected", color: "#ef4444", icon: FaTimes },
];

//Created By Cursor
const formatMoney = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return n.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
};

//Created By Cursor
const studentRelation = (gender) => {
  const g = String(gender || "").toLowerCase();
  if (g.startsWith("f") || g === "female" || g === "girl") return "D/O";
  return "S/O";
};

//Created By Cursor
const studentInitials = (name) => {
  const parts = String(name || "?")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0]?.[0] || "?").toUpperCase();
};

//Created By Cursor
const hasStudentImage = (path) => {
  const p = String(path || "").trim();
  if (!p) return false;
  const lower = p.toLowerCase();
  return !(
    lower === "null" ||
    lower === "undefined" ||
    lower.endsWith("/null") ||
    lower.includes("noimage") ||
    lower.includes("no_image") ||
    lower.includes("default.jpg") ||
    lower.includes("placeholder")
  );
};

//Created By Cursor
const StudentThumb = ({ name, imagePath }) => {
  const [imgFailed, setImgFailed] = useState(false);

  useEffect(() => {
    setImgFailed(false);
  }, [imagePath]);

  const showImg = hasStudentImage(imagePath) && !imgFailed;

  return showImg ? (
    <img
      src={imagePath}
      alt=""
      className="stl-card__avatar"
      onError={() => setImgFailed(true)}
    />
  ) : (
    <span className="stl-card__initials" title={name || "Student"}>
      {studentInitials(name)}
    </span>
  );
};

const Settlement = () => {
  const token = localStorage.getItem("token");
  const [loggedIn] = useState(token !== null);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [sessionName, setSessionName] = useState("");
  const [sessionStatus, setSessionStatus] = useState("");
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const [settlement, setSettlement] = useState([]);
  const [settlementRequest, setSettlementRequest] = useState(0);
  const [dueSettledAmount, setDueSettledAmount] = useState(0);
  const [feeSettledAmount, setFeeSettledAmount] = useState(0);
  const [actionKey, setActionKey] = useState("");

  //Created By Cursor
  const getFeeSettlementDashboard = useCallback((session_id, soft = false) => {
    if (!session_id) return;
    if (soft) setRefreshing(true);
    else setLoading(true);

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getFeeSettlementDashboard.php";
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;

    axios
      .get(URL, {
        params: { school_code: SCHOOL_CODE, session_id },
      })
      .then((res) => res.data)
      .then((response) => {
        if (response.api_status === "OK") {
          const list = response?.dashboard?.settlement_request_list;
          setSettlement(Array.isArray(list) ? list : []);
          setSettlementRequest(response.dashboard?.settlement_request ?? 0);
          setDueSettledAmount(response.dashboard?.due_settled_amount ?? 0);
          setFeeSettledAmount(response.dashboard?.fee_settled_amount ?? 0);
        } else {
          setSettlement([]);
          myToast.notify_warning(response.api_remark || "Failed to load settlement.");
        }
      })
      .catch((error) => {
        setSettlement([]);
        console.error("Error fetching settlement dashboard:", error);
        myToast.notify_error("Failed to load settlement dashboard.");
      })
      .finally(() => {
        setLoading(false);
        setRefreshing(false);
      });
  }, []);

  useEffect(() => {
    const mSession = SessionManager.getCurrentSession();
    const sid = mSession?.[0]?.session_id || "";
    setSessionId(sid);
    setSessionName(mSession?.[0]?.session_name || "");
    setSessionStatus(mSession?.[0]?.status || "");
    window.scrollTo(0, 0);
    if (sid) getFeeSettlementDashboard(sid);
    else setLoading(false);
  }, [getFeeSettlementDashboard]);

  //Created By Cursor
  const updateSettlementStatus = async (item, settlement_status) => {
    const key = `${item.settlement_request_id || item.id}-${settlement_status}`;
    setActionKey(key);
    try {
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const mStaffData = SessionManager.getStaffDetails();
      const STAFF_ID = mStaffData?.staff_id;
      const FUNCTION_NAME = "updateSettlementRequest.php";
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

      const params = {
        school_code: SCHOOL_CODE,
        request_id: item.settlement_request_id,
        student_id: item.student_id,
        session_id: item.session_id,
        class_id: item.class_id,
        section_id: item.section_id,
        staff_id: STAFF_ID,
        fee_id: item.fee_id,
        applicable_month: item.applicable_month,
        amount: item.due_amount,
        settlement_status,
      };

      const response = await axios.get(URL, { params });

      if (response.data.api_status === "OK") {
        myToast.notify_success(
          settlement_status === "2"
            ? "Amount settled successfully."
            : "Request rejected."
        );
        getFeeSettlementDashboard(sessionId, true);
      } else {
        myToast.notify_warning(
          response.data.api_remark || "Update failed. Please try again."
        );
      }
    } catch (error) {
      console.error("Settlement update error:", error);
      myToast.notify_error("An error occurred while updating the request.");
    } finally {
      setActionKey("");
    }
  };

  //Created By Cursor
  const handleReject = (item) => {
    if (!window.confirm("Reject this settlement request?")) return;
    updateSettlementStatus(item, "3");
  };

  //Created By Cursor
  const handleSettle = (item) => {
    if (!window.confirm("Settle this request?")) return;
    updateSettlementStatus(item, "2");
  };

  const handleSessionDialogToggle = () => {
    setIsOpenSessionDialog((prev) => !prev);
  };

  //Created By Cursor
  const handleSelectedSession = (
    session_id,
    session_name,
    session_status
  ) => {
    setSessionId(session_id);
    setSessionName(session_name);
    setSessionStatus(session_status || "");
    setIsOpenSessionDialog(false);
    getFeeSettlementDashboard(session_id);
  };

  const settlementList = useMemo(
    () => (Array.isArray(settlement) ? settlement : []),
    [settlement]
  );

  const tabCounts = useMemo(() => {
    const counts = { "1": 0, "2": 0, "3": 0 };
    settlementList.forEach((item) => {
      const status = String(item?.settlement_status || "");
      if (counts[status] !== undefined) counts[status] += 1;
    });
    return counts;
  }, [settlementList]);

  const filteredList = useMemo(
    () =>
      settlementList.filter(
        (item) => String(item?.settlement_status) === String(activeTab)
      ),
    [settlementList, activeTab]
  );

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <Router>
      <Switch>
        <Route
          path="/AdminMain/Settlement"
          render={() => (
            <div
              className="content payroll-page sm-page tr-page trep-page stl-page"
              style={{
                background: COLORS.white,
                fontFamily:
                  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
              }}
            >
              <div
                className="content-header"
                style={{ background: COLORS.primary_color_shade5 }}
              >
                <div className="leftside-content-header">
                  <ul className="breadcrumbs">
                    <li>
                      <i
                        className="fa fa-home"
                        aria-hidden="true"
                        style={{ color: COLORS.white }}
                      />
                      <span style={{ color: COLORS.white }}> Settlement</span>
                    </li>
                  </ul>
                </div>
                <div className="rightside-content-header">
                  <BackButton />
                </div>
              </div>

              <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell">
                <header
                  className="sm-hero"
                  style={{ "--sm-hero-bg": HERO_GRADIENT }}
                >
                  <div className="sm-hero__brand">
                    <div className="sm-hero__icon" aria-hidden>
                      <FaHandHoldingUsd />
                    </div>
                    <div className="min-w-0">
                      <h1 className="sm-hero__title">Settlement</h1>
                      <p className="sm-hero__sub">
                        Fee &amp; due settlement requests · Session{" "}
                        {sessionName || "—"}
                      </p>
                    </div>
                  </div>

                  <div className="sm-hero__tools">
                    <button
                      type="button"
                      onClick={() =>
                        getFeeSettlementDashboard(sessionId, true)
                      }
                      disabled={refreshing || loading || !sessionId}
                      className={`pp-icon-btn${refreshing ? " spinning" : ""}`}
                      title="Refresh"
                      aria-label="Refresh"
                    >
                      <FaSyncAlt aria-hidden />
                    </button>
                  </div>
                </header>

                <div className="tr-content trep-content">
                  <Link
                    to="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setIsOpenSessionDialog(true);
                    }}
                    className="trep-session"
                  >
                    <span>
                      Session: {sessionName || "—"}
                      {sessionStatus ? ` (${sessionStatus})` : ""}
                    </span>
                    <img
                      src={uploadIcon}
                      alt=""
                      className="trep-session__icon"
                    />
                  </Link>

                  {loading ? (
                    <div className="tr-loading">
                      <MyLoader />
                    </div>
                  ) : (
                    <>
                      <div className="sm-kpi-row" aria-label="Settlement summary">
                        <div className="sm-kpi-chip sm-kpi-chip--sand">
                          <span className="sm-kpi-chip__icon" aria-hidden>
                            <FaClock />
                          </span>
                          <div className="sm-kpi-chip__text">
                            <span className="sm-kpi-chip__label">
                              Settlement request
                            </span>
                            <span className="sm-kpi-chip__value">
                              ₹{formatMoney(settlementRequest)}
                            </span>
                          </div>
                        </div>
                        <div className="sm-kpi-chip sm-kpi-chip--mint">
                          <span className="sm-kpi-chip__icon" aria-hidden>
                            <FaRupeeSign />
                          </span>
                          <div className="sm-kpi-chip__text">
                            <span className="sm-kpi-chip__label">
                              Due settled
                            </span>
                            <span className="sm-kpi-chip__value">
                              ₹{formatMoney(dueSettledAmount)}
                            </span>
                          </div>
                        </div>
                        <div className="sm-kpi-chip sm-kpi-chip--sky">
                          <span className="sm-kpi-chip__icon" aria-hidden>
                            <FaHandHoldingUsd />
                          </span>
                          <div className="sm-kpi-chip__text">
                            <span className="sm-kpi-chip__label">
                              Fee settled
                            </span>
                            <span className="sm-kpi-chip__value">
                              ₹{formatMoney(feeSettledAmount)}
                            </span>
                          </div>
                        </div>
                      </div>

                      {/* Created By Cursor — primary settlement actions */}
                      <div
                        className="stl-action-row"
                        aria-label="Settlement actions"
                      >
                        <Link
                          to="/AdminMain/SettlementFeeAdvance"
                          className="stl-action-btn stl-action-btn--primary"
                        >
                          <span className="stl-action-btn__icon" aria-hidden>
                            <FaHandHoldingUsd />
                          </span>
                          <span className="stl-action-btn__text">
                            <span className="stl-action-btn__title">
                              Settle Fee And Due
                            </span>
                            <span className="stl-action-btn__sub">
                              Clear current fee or due
                            </span>
                          </span>
                        </Link>
                        <button
                          type="button"
                          className="stl-action-btn stl-action-btn--debt stl-action-btn--disabled"
                          disabled
                          aria-disabled="true"
                          title="Debt Management is currently disabled"
                        >
                          <span className="stl-action-btn__icon" aria-hidden>
                            <FaFileInvoiceDollar />
                          </span>
                          <span className="stl-action-btn__text">
                            <span className="stl-action-btn__title">
                              Debt Management
                            </span>
                            <span className="stl-action-btn__sub">
                              Manage old due balances
                            </span>
                          </span>
                        </button>
                      </div>

                      <section
                        className="trep-panel"
                        aria-label="Settlement requests"
                      >
                        <div className="trep-panel__head">
                          <div className="min-w-0">
                            <h2 className="trep-panel__title">
                              <FaUserGraduate aria-hidden /> Recent requests
                            </h2>
                            <p className="trep-panel__sub">
                              Review pending settlements and act quickly
                            </p>
                          </div>
                          <span className="trep-panel__count">
                            {filteredList.length} shown
                          </span>
                        </div>

                        <div className="stl-body">
                          <div
                            className="trep-chips"
                            role="tablist"
                            aria-label="Request status"
                          >
                            {TABS.map((tab) => {
                              const Icon = tab.icon;
                              const active = activeTab === tab.value;
                              return (
                                <button
                                  key={tab.value}
                                  type="button"
                                  role="tab"
                                  aria-selected={active}
                                  className={`trep-chip${
                                    active ? " is-active" : ""
                                  }`}
                                  style={
                                    active
                                      ? {
                                          borderColor: tab.color,
                                          color: tab.color,
                                          background: `${tab.color}12`,
                                        }
                                      : undefined
                                  }
                                  onClick={() => setActiveTab(tab.value)}
                                >
                                  <Icon aria-hidden />
                                  <span>{tab.label}</span>
                                  <span className="stl-tab-count">
                                    {tabCounts[tab.value] || 0}
                                  </span>
                                </button>
                              );
                            })}
                          </div>

                          {filteredList.length === 0 ? (
                            <div className="sm-empty">
                              <p className="sm-empty__title">
                                No {TABS.find((t) => t.value === activeTab)?.label?.toLowerCase()} requests
                              </p>
                              <p className="sm-empty__hint">
                                Switch tabs or refresh after selecting another
                                session.
                              </p>
                            </div>
                          ) : (
                            <div className="stl-list">
                              {filteredList.map((item, index) => {
                                const student =
                                  item?.student_details?.[0] || {};
                                const classInfo = student?.class?.[0] || {};
                                const rowKey =
                                  item.settlement_request_id ||
                                  item.id ||
                                  `${item.student_id}-${index}`;
                                const settleBusy =
                                  actionKey ===
                                  `${item.settlement_request_id || item.id}-2`;
                                const rejectBusy =
                                  actionKey ===
                                  `${item.settlement_request_id || item.id}-3`;

                                return (
                                  <article
                                    key={rowKey}
                                    className="stl-card"
                                  >
                                    <StudentThumb
                                      name={student.stu_name || "Student"}
                                      imagePath={student.student_img_path}
                                    />
                                    <div className="stl-card__main">
                                      <h3 className="stl-card__name">
                                        {student.stu_name || "Student"}{" "}
                                        <span className="stl-card__relation">
                                          {studentRelation(student.gender)}{" "}
                                          {student.father_name || "—"}
                                        </span>
                                      </h3>
                                      <p className="stl-card__meta">
                                        Month: {item.applicable_month || "—"} ·
                                        Amount: ₹
                                        {formatMoney(item.due_amount)}
                                      </p>
                                      <div className="stl-card__tags">
                                        <span>
                                          Roll {classInfo.student_roll_no || "—"}
                                        </span>
                                        <span>
                                          {classInfo.class_name || "—"}
                                          {classInfo.section_name
                                            ? ` · ${classInfo.section_name}`
                                            : ""}
                                        </span>
                                      </div>
                                    </div>
                                    {activeTab === "1" ? (
                                      <div className="stl-card__actions">
                                        <button
                                          type="button"
                                          className="stl-btn stl-btn--danger"
                                          disabled={!!actionKey}
                                          onClick={() => handleReject(item)}
                                        >
                                          {rejectBusy ? "…" : "Reject"}
                                        </button>
                                        <button
                                          type="button"
                                          className="stl-btn stl-btn--success"
                                          disabled={!!actionKey}
                                          onClick={() => handleSettle(item)}
                                        >
                                          {settleBusy ? "…" : "Settle"}
                                        </button>
                                      </div>
                                    ) : null}
                                  </article>
                                );
                              })}
                            </div>
                          )}

                          <div className="stl-footer">
                            <Link
                              to="/AdminMain/ViewSettlement"
                              className="stl-view-all"
                            >
                              <span className="stl-view-all__icon" aria-hidden>
                                <FaListUl />
                              </span>
                              <span className="stl-view-all__body">
                                <span className="stl-view-all__title">
                                  View all settlement requests
                                </span>
                                <span className="stl-view-all__sub">
                                  {settlementList.length} total · filter by
                                  class &amp; status
                                </span>
                              </span>
                              <span className="stl-view-all__chevron" aria-hidden>
                                →
                              </span>
                            </Link>
                          </div>
                        </div>
                      </section>
                    </>
                  )}
                </div>
              </div>

              {isOpenSessionDialog ? (
                <MdlSelectSession
                  action={handleSessionDialogToggle}
                  action2={handleSelectedSession}
                />
              ) : null}
            </div>
          )}
        />
        <Route
          path="/AdminMain/OldDueCollection"
          component={OldDueCollection}
        />
        <Route path="/AdminMain/OldDueList/:tag" component={OldDueList} />
        <Route path="/AdminMain/ViewSettlement" component={ViewSettlement} />
        <Route
          path="/AdminMain/SettlementFeeAdvance"
          component={SettlementFeeAdvance}
        />
      </Switch>
    </Router>
  );
};

export default Settlement;
